import React from 'react'
import Navbar from '../../components/Navbar'
import { Box,List,  ListItem, Typography, Card, Tab, Tabs, Paper, Divider } from '@mui/material'
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Grid from '@mui/material/Grid';
import Footer from '../../components/Footer'
const Collections=(props)=> {



    const ListContent1=[
        'Volumes – 51115',
        'Titles – 7571',
        'Journals– 23',
        ]
      
      
    const ListContent2=[
        'CD- ROMs and DVDs – 3165',
        'Floppies - 348',
        'Project Reports – 2000',
        'Bound Volumes – 185',
        'Conference Proceedings – 12',
        'News Papers - 09',
        'Thesis - 10',
        'General Magazines- 06'    
    ]

    const ListContent3=[
        'E-Journals – 7759',
        'E-Books – 39380']



    const JournalList={
        'CSE/ISE/AIML':[
            'International Journal of Web Applications',
            'International Journal of Computational Linguistics Research', 
            'Journal of Android and IOS Applications and Testing',
            'Journal of Intelligent Computing',
            'Journal of Multimedia Processing and Technologies',
            'Journal of Data Processing',
            'Indian Journal of Neural Network Research', 
            'Indian Journal of Computer Graphics and Visualization',
            'Indian Journal of Mobile Computing'
        ],
        'Electronics and Communication Engineering':[
            'Indian Journal of Electronic Engineering',
           'Indian Journal of Electronics and Communication Engineering',
            'Indian Journal of Wireless Communication ',
           'Journal of Electronic Design Engineering'
        ],

        'Mechanical Engineering':[
            'Manufacturing Technology Today',
            'Indian Journal Of Engineering and Material Science',
            'The IUP Journal Of Mechanical Engineering',
            'Journal of Manufacturing Engineering',
        ],

        'Basic Science':[
            'INTERNATIONAL JNL. Of Physics',
            'INT.JNL. Of Materials Physics',
            'INT.JNL. Of Pure & Applied Chemistry',
            'INT.JNL. Of Chemistry & Chemical Eng',
           ' Advances In Fuzzy Mathematics',
            'INTL. JNL. Of Statistics & Systems',

        ]
        
       
    }

    const MagazineList={
        'Name of the Magazine':[
            'Data quest',
            'Electronics for you',
            'Open source for you',
            'Pc-quest',
            'Csr-general knowledge today ',
            'The week',

        ],
    }


    const NewspaperList={
        'Name of the Newspapers':[
            'Times of India',
            'Deccan Herald',
            'Indian Express',
            'Bangalore Mirror',
            'The Hindu',
            'Prajavani',
            'Vijay Karnataka',
            'Kannada Prabha',
            'SALAR (Urdu)',


        ],
    }

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }
    
  
  return (
    <Grid>
    <Box top={0} position={'sticky'} zIndex={25}><Navbar/></Box>
    <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
      <img
        src='/imgs/Bg1.jpg'
        alt="Background "
        style={{
          objectFit:'cover',
          width: '100%',
          height: '100%',
        }}
      />
      
        <Typography variant='h3'   color={'#fff'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
        Collection
        </Typography>
   </Box>
   <Grid container spacing={4} sx={{ display: 'flex', justifyContent:'center', alignContent:'center', minHeight:'75vh',p:'3%' }}>
        {/* Column 1 */}
        <Grid item  xs={12} md={4}>
            <Card sx={{backgroundColor:'primary.main'}}>
                <List >
                <Typography variant='h5' p={2} textAlign={'left'}>
                    BOOKS
                    </Typography>
                    {ListContent1.map((item, key) => (
                    <ListItem key={key} sx={{ p: 2, maxWidth:'45vw' }}>
                
                        <ArrowRightIcon color='primary.dark' fontSize='medium' />
                
                        <Typography >{item}</Typography>
                    </ListItem>
                    ))}
                </List>
            </Card>
        </Grid >

        {/* Column 2 */}
        <Grid item  xs={12} md={4}>
            <Card  sx={{backgroundColor:'primary.main'}}>
                <List >
                    <Typography variant='h5' p={2} textAlign={'left'}>
                    NON – BOOK MATERIALS
                        </Typography>
                    {ListContent2.map((item, key) => (
                    <ListItem key={key} sx={{ p: 2, maxWidth:'45vw'}}>
                
                        <ArrowRightIcon color='primary.dark' fontSize='medium' />
                
                        <Typography >{item}</Typography>
                    </ListItem>
                    ))}
                </List>
            </Card>
        </Grid>
            
        {/* Column 3 */}
        <Grid item  xs={12} md={4}>
            <Card  sx={{backgroundColor:'primary.main'}}>
                <List >
                    <Typography variant='h5' p={2} textAlign={'left'}>
                    E-RESOURCES
                        </Typography>
                    {ListContent3.map((item, key) => (
                    <ListItem key={key} sx={{ p: 2, maxWidth:'45vw'}}>
                
                        <ArrowRightIcon color='primary.dark' fontSize='medium' />
                
                        <Typography >{item}</Typography>
                    </ListItem>
                    ))}
                </List>
            </Card>
        </Grid>
        
        <Paper elevation={6} sx={{m:3}} >
      
            <TabContext value={value} >
            
                <Card  sx={{ flexGrow: 1, display: 'flex', minHeight: 224, }}>
                    <Tabs orientation="vertical" onChange={handleChange} indicatorColor='#000'  sx={{backgroundColor:'#fff', p:3}}  >
                        <Tab label="Journals" value="1"sx={{color:'#fff', backgroundColor:'secondary.light',my:3}} />
                        <Divider sx={{borderColor:'#fff'}}/>
                        <Tab label="Magazines" value="2" sx={{color:'#fff', backgroundColor:'secondary.light' ,my:3}} />
                        <Divider sx={{borderColor:'#fff'}}/>
                        <Tab label="Newspapers" value="3" sx={{color:'#fff', backgroundColor:'secondary.light' ,my:3}} />
                        <Divider sx={{borderColor:'#fff'}}/>
                    </Tabs>



                    <Box  backgroundColor={'primary.main'} >
                        <TabPanel value="1" sx={{borderRadius:20}}>
                            {Object.entries(JournalList).map(([title,list,])=>(
                                <Grid direction={'column'} container m={3} p={2} key={title}>
                                    <Card sx={{backgroundColor:'#fff', color:'secondary.main', p:3}}>
                                        <Grid item>
                                            <Typography textAlign={'left'} variant='h6'>{title}</Typography>
                                        </Grid>
                                        
                                        {list.map((item,key)=>(
                                        <Grid display={'flex'} key={key} direction={'row'}>
                                            <ArrowRightIcon color='primary.dark' fontSize='medium' />
                                            <Typography textAlign={'left'}>{item}</Typography>
                                        </Grid>
                                        ))}
                                    </Card>

                                </Grid>
                            ))}
                        </TabPanel>


                        <TabPanel value="2"> {Object.entries(MagazineList).map(([title,list,])=>(
                                <Grid direction={'column'} container m={3} p={2} key={title}>
                                    <Card sx={{backgroundColor:'#fff', color:'secondary.main', p:3}}>
                                        <Grid item>
                                            <Typography textAlign={'left'} variant='h6'>{title}</Typography>
                                        </Grid>
                                        
                                        {list.map((item,key)=>(
                                        <Grid display={'flex'} key={key} direction={'row'}>
                                            <ArrowRightIcon color='primary.dark' fontSize='medium' />
                                            <Typography textAlign={'left'}>{item}</Typography>
                                        </Grid>
                                        ))}
                                    </Card>

                                </Grid>
                            ))}</TabPanel>


                        <TabPanel value="3"> {Object.entries(NewspaperList).map(([title,list,])=>(
                                <Grid direction={'column'} container m={3} p={2} key={title}>
                                    <Card sx={{backgroundColor:'#fff', color:'secondary.main', p:3}}>
                                        <Grid item>
                                            <Typography textAlign={'left'} variant='h6'>{title}</Typography>
                                        </Grid>
                                        
                                        {list.map((item,key)=>(
                                        <Grid display={'flex'} key={key} direction={'row'}>
                                            <ArrowRightIcon color='primary.dark' fontSize='medium' />
                                            <Typography textAlign={'left'}>{item}</Typography>
                                        </Grid>
                                        ))}
                                    </Card>

                                </Grid>
                            ))}</TabPanel>

                    </Box>
                </Card>
        
            </TabContext>
            
        </Paper>


    </Grid>





    <Footer/>
</Grid>
  )
}
export default Collections
